export default __webpack_public_path__ + "static/media/precision-open.6f8dd1ca.png";